import { faPlain } from 'utilities/helper/format'

/**
 * Cashbox state labels.
 *
 * The previous map read `{nct: 'پیش نویس', act: 'پیش نویس', dft: 'پیش نویس'}`,
 * which mislabels two of the three: per `utils/constants/choice.py:18`
 * `act` is Activated and `nct` is In-activated. A running box was being shown
 * to its members as «پیش نویس».
 *
 * `nct` is doubly loaded on the backend — it is both "never activated yet" and
 * "period finished, box closed" (`draw` sets it after the last cycle). Use
 * `cashboxStateLabel`, which disambiguates using the period, wherever the
 * period is in hand; `StateConvertor` stays for callers that only have state.
 */
export const StateConvertor: { [key: string]: string } = {
    act: 'فعال',
    nct: 'غیرفعال',
    dft: 'پیش‌نویس',
    unp: 'در انتظار پرداخت اشتراک',
}

export const cashboxStateLabel = (
    state: string,
    period?: { is_terminated?: boolean; cycle_index?: number }
): string => {
    if (state === 'nct') {
        // A box that ran at least one cycle and is now inactive has finished
        // its دوره; one that never ran simply has not started.
        if (period && (period.cycle_index ?? 0) > 0) return 'دوره پایان‌یافته'
        return 'شروع‌نشده'
    }
    return StateConvertor[state] ?? 'نامشخص'
}

/** Chip colours, keyed by state. Mirrors the funds-list chips. */
export const cashboxStateChip = (
    state: string
): { bgColor: string; color: string } => {
    switch (state) {
        case 'act':
            return { bgColor: '#E6F3DD', color: '#4CA632' }
        case 'unp':
            return { bgColor: '#E5F0F8', color: '#2FACFF' }
        default:
            return { bgColor: '#DCE0E5', color: '#646E7A' }
    }
}

export const CASHBOX_ROLE_LABELS: { [key: string]: string } = {
    own: 'مدیر',
    mgr: 'مدیر مالی',
    nrm: 'عضو',
}

/**
 * «ماهانه، ۱۵اُم هر ماه».
 *
 * Formatted, not interpolated raw: a bare `${dayOfDraw}` renders Latin digits
 * in the middle of a line of Persian ones — «ماهانه، 15اُم هر ماه» — which is
 * the sort of thing that reads as a half-finished translation. `faPlain` and
 * not `faFull` because this is a day of the month, not an amount, and grouping
 * a number this small is meaningless.
 */
export const cashboxIntervalLabel = (interval: string, dayOfDraw: number) =>
    interval === 'w'
        ? `هفتگی، روز ${faPlain.format(dayOfDraw)}`
        : `ماهانه، ${faPlain.format(dayOfDraw)}اُم هر ماه`
